<template>
  <div class="online-renewal-start">
    <v-container>
      <v-layout row wrap>
        <v-flex md4 offset-md4>
          <center>
            <h1 class="start-title">Start your online renewal</h1>
            <v-layout>
                <v-flex md8 offset-md2>
                    <v-text-field
                    label="Quote Reference"
                    placeholder="Enter your quote reference id here"
                    v-model="quoteReferenceId"
                    ></v-text-field>
                    <button class="green-button"
                    v-if="quoteReferenceId"
                    @click="redirect()">Continue</button>
                </v-flex>
            </v-layout>
          </center>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style lang="css" scoped>
.online-renewal-start {
  background-color: white;
  min-height: 64vh;
}
.start-title {
  color: #d93b20;
  font-weight: bolder;
  margin: 60px auto 20px auto;
}
</style>

<script>
export default {
    data() {
        return {
            quoteReferenceId: null
        }
    },
    computed: {
      fetchSessionDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'session_by_reference_id',
                    id: this.quoteReferenceId,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchQuoteDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'quote_by_session_id',
                    session_id: this.$store.state.sessionDetails.id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchPreviousPolicyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_policies_by_policy_id.json`,
                params: {
                    id: this.$store.state.sessionDetails.properties.previous_policy_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchCompanyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_company.json`,
                params: {
                    id: this.$store.state.previousPolicyDetails.properties.company_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }   
        },
    },
    methods: {
        async fetchSessionDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchSessionDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.state.sessionDetails = response.data.items.results[0];
                this.$store.commit('mutate', {
                    property: 'sessionDetails',
                    value: response.data.items.results[0]
                })
                this.$store.commit('mutate', {
                    property: 'onlineRenewalPaymentTerms',
                    value: this.$store.state.sessionDetails.properties.payment_terms
                });
                this.fetchQuoteDetails();
            }
        },
        async fetchQuoteDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchQuoteDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'quoteDetails',
                    value: response.data.items.results[0]
                })
                this.fetchPreviousPolicyDetails();
            }
        },
        async fetchPreviousPolicyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchPreviousPolicyDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'previousPolicyDetails',
                    value: response.data.items.results[0]
                })
                this.fetchCompanyDetails();
            }
        },
        async fetchCompanyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchCompanyDetailsPayload)
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'companyDetails',
                    value: response.data.items.results[0]
                })
            }
        },
        async redirect() {
            if(this.quoteReferenceId !== "" && this.quoteReferenceId !== undefined && this.quoteReferenceId !== null) {

              let payload = {
                  method: 'get',
                  url: `${this.baseURL}/api/cfa/get_session_by_reference_id.json`,
                  params: {
                      id: this.quoteReferenceId
                  }
              },
              response = await this.$store.dispatch('fetchData', payload);
              if(response.data.items.results.length === 0) {
                Swal.fire({
                  type: 'error',
                  title: 'Oops...',
                  text: 'This is not a valid reference id!'
                })
              } else {
                this.$store.commit('mutate', {
                  property: 'onlineRenewalQuoteReferenceId',
                  value: this.quoteReferenceId
                })
                this.fetchSessionDetails();
              }

              
            }
        }
    },
    mounted: function() {
    }
}
</script>
